import { REVIEW } from '@/api'
import { ReviewType } from '@/constants/enums'
import { AUTH_LOAD_PROFILE } from './auth.module'

/* Define Module Name */
// const MODULE_NAME = "review/";

/* Define Action Name */
const A_GET_MYREVIEW_SALONSTYLIST_TOREVIEW = 'fetchMyReviewSalonStylistToReview'
const A_CREATE_SALONSTYLIST_REVIEW = 'createSalonStylistReview'

/* Define Getter Name */
const G_GET_MYREVIEW_SALONSTYLIST_TOREVIEW_BY_POSTRANSID = 'getMyReviewSalonStylistToReviewByPosTransId'

/* Define Mutation Name */
const M_SET_MYREVIEW_SALONSTYLIST_TOREVIEW = 'setMyReviewSalonStylistToReview'
const M_SET_SALONTYLIST_REVIEW_FORM = 'setSalonStylistReviewForm'
const M_RESET_SALONTYLIST_REVIEW_FORM = 'resetSalonStylistReviewForm'

/* Define Export Name */

const state = {
  salonStylistReviewForm: {
    posTransId: null,
    reviews: [],
    comments: []
  },
  salonStylistToReview: null,
  salonStylistHistory: []
}

//Getters
const getters = {
  [G_GET_MYREVIEW_SALONSTYLIST_TOREVIEW_BY_POSTRANSID]: (state) => (posTransId) => {
    return state.salonStylistToReview.find((review) => review.pos_transaction_id == posTransId)
  }
}

// Actions
const actions = {
  async [A_GET_MYREVIEW_SALONSTYLIST_TOREVIEW]({ commit }) {
    await REVIEW.getMyReview({ type: ReviewType.SALON_STYLIST, review_type: ReviewType.TO_REVIEW }).then((response) => {
      commit(M_SET_MYREVIEW_SALONSTYLIST_TOREVIEW, response)
    })
  },

  async [A_CREATE_SALONSTYLIST_REVIEW]({ commit, dispatch }, data) {
    await REVIEW.submitReview(data).then((_) => {
      commit(M_RESET_SALONTYLIST_REVIEW_FORM)
      dispatch(AUTH_LOAD_PROFILE, null, { root: true })
    })
  }
}

// Mutations
const mutations = {
  [M_SET_MYREVIEW_SALONSTYLIST_TOREVIEW](state, reviews) {
    state.salonStylistToReview = reviews.list
  },
  [M_SET_SALONTYLIST_REVIEW_FORM](state, form) {
    const { posTransId, reviews, comments } = form

    if (posTransId) {
      state.salonStylistReviewForm.posTransId = posTransId
    }
    if (reviews) {
      state.salonStylistReviewForm.reviews = [...state.salonStylistReviewForm.reviews, ...reviews]
    }
    if (comments) {
      state.salonStylistReviewForm.comments = [...state.salonStylistReviewForm.comments, ...comments]
    }
  },
  [M_RESET_SALONTYLIST_REVIEW_FORM](state) {
    state.salonStylistReviewForm = {
      posTransId: null,
      reviews: [],
      comments: []
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
